"use strict";

import Swiper from 'swiper';

export function initInScope ($scope) {
    $scope.find('.js-flugblatt-swiper-container').each(function (index, value) {
        let $swiperContainer = $(this),
            $swiperMain = $swiperContainer.find('.js-flugblatt-swiper__main'),
            $swiperNav = $swiperContainer.find('.js-flugblatt-swiper__nav'),
            $swiperArrowContainerMain = $swiperMain.closest('.js-swiper-arrow-container'),
            $swiperArrowContainerNav = $swiperNav.closest('.js-swiper-arrow-container');

        let swiperNav = new Swiper ($swiperNav, {
            loop: false,
            slidesPerView: 4,
            spaceBetween: 10,
            keyboard: {
                enabled: true,
            },
            navigation: {
                nextEl: $swiperArrowContainerNav.find('.js-swiper__next'),
                prevEl: $swiperArrowContainerNav.find('.js-swiper__prev'),
            },
            breakpoints: {
                // when window width is >= 768px
                768: {
                    slidesPerView: 5
                },
                // when window width is >= 1300px
                1300: {
                    spaceBetween: 40,
                    slidesPerView: 5
                }
            },
            on: {
                init: function () {
                    setTimeout(() => {
                        window.dispatchEvent(new Event("resize"));
                    }, 200)
                },
            }
        });

        new Swiper ($swiperMain, {
            loop: false,
            slidesPerView: 1,
            keyboard: {
                enabled: true,
            },
            navigation: {
                nextEl: $swiperArrowContainerMain.find('.js-swiper__next'),
                prevEl: $swiperArrowContainerMain.find('.js-swiper__prev'),
            },
            pagination: {
                el: $swiperContainer.find('.js-swiper__pagination'),
                clickable: true
            },
            thumbs: {
                swiper: swiperNav
            },
            on: {
                init: function () {
                    setTimeout(() => {
                        window.dispatchEvent(new Event("resize"));
                    }, 200)
                },
            }

        });

    });
    

}